var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _path37, _path38, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 220,
    viewBox: "0 0 370 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0942 65.3432L46.2326 61.2232C46.8363 60.876 47.3268 61.1552 47.3268 61.857V70.0972C47.3268 70.7914 46.8363 71.6441 46.2326 71.9912L39.0942 76.1113C38.4905 76.4584 38 76.1792 38 75.4774V67.2373C38.0075 66.543 38.4905 65.6903 39.0942 65.3432Z",
    fill: "#374A57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5234 61.6311L46.9949 61.1406L47.9759 61.7066L46.0064 62.4159L45.5234 61.6311Z",
    fill: "#374A57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2871 76.1568L40 75.5078L40.9885 76.0738L39.3058 76.7378L38.2871 76.1568Z",
    fill: "#374A57"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0238 76.6412L47.1623 72.5211C47.766 72.174 48.2564 71.3288 48.2564 70.6271V62.3869C48.2564 61.6927 47.766 61.4059 47.1623 61.7531L40.0238 65.8731C39.4202 66.2202 38.9297 67.0654 38.9297 67.7672V76.0073C38.9297 76.7015 39.4202 76.9883 40.0238 76.6412Z",
    fill: "#8A9CA8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6641 63.4269C46.6641 63.6684 46.8301 63.7665 47.0414 63.6457C47.2526 63.525 47.4187 63.2307 47.4187 62.9893C47.4187 62.7478 47.2526 62.6497 47.0414 62.7704C46.8301 62.8912 46.6641 63.1854 46.6641 63.4269Z",
    fill: "#374A57"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7578 67.4152C39.7578 67.6567 39.9238 67.7548 40.1351 67.634C40.3464 67.5133 40.5124 67.219 40.5124 66.9775C40.5124 66.7361 40.3464 66.638 40.1351 66.7587C39.9314 66.8794 39.7578 67.1737 39.7578 67.4152Z",
    fill: "#374A57"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6641 71.3214C46.6641 71.5629 46.8301 71.661 47.0414 71.5403C47.2526 71.4195 47.4187 71.1253 47.4187 70.8838C47.4187 70.6423 47.2526 70.5442 47.0414 70.6649C46.8376 70.7857 46.6641 71.08 46.6641 71.3214Z",
    fill: "#3C3C3B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7578 75.3058C39.7578 75.5473 39.9238 75.6454 40.1351 75.5247C40.3464 75.4039 40.5124 75.1096 40.5124 74.8682C40.5124 74.6267 40.3464 74.5286 40.1351 74.6493C39.9314 74.7701 39.7578 75.0644 39.7578 75.3058Z",
    fill: "#374A57"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9688 70.1278C41.9688 71.1616 42.6932 71.5842 43.5911 71.0635C44.4891 70.5429 45.2135 69.2902 45.2135 68.2565C45.2135 67.2227 44.4891 66.8001 43.5911 67.3208C42.6932 67.8414 41.9688 69.0941 41.9688 70.1278Z",
    fill: "#3C3C3B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4492 70.6923C41.4492 72.3448 42.6113 73.0164 44.045 72.1939C45.4787 71.3638 46.6408 69.3491 46.6408 67.6965C46.6408 66.044 45.4787 65.3724 44.045 66.1949C42.6113 67.0249 41.4492 69.0397 41.4492 70.6923Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3847 73.273C53.9129 73.273 54.4034 72.9259 54.5618 72.3977C54.758 71.7488 54.3883 71.0696 53.7393 70.8734L44.5484 68.1418C43.8994 67.9456 43.3938 68.3229 43.1977 68.9719C43.0015 69.6208 43.1977 70.2999 43.8466 70.4886L53.0375 73.2202C53.1507 73.2579 53.2715 73.273 53.3847 73.273Z",
    fill: "#8A9CA8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5684 72.0504C51.5684 73.5219 52.7606 74.7141 54.2321 74.7141C55.7035 74.7141 56.8958 73.5219 56.8958 72.0504C56.8958 70.579 55.7035 69.3867 54.2321 69.3867C52.7606 69.3867 51.5684 70.579 51.5684 72.0504Z",
    fill: "#374A57"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8515 71.1068C55.4023 71.1068 55.9079 70.7295 56.0437 70.1711L58.0887 61.7046C58.2471 61.0481 57.8396 60.3841 57.1832 60.2256C56.5267 60.0671 55.8626 60.4746 55.7041 61.1311L53.6592 69.5976C53.5007 70.2541 53.9082 70.9182 54.5647 71.0766C54.6628 71.0993 54.7534 71.1068 54.8515 71.1068Z",
    fill: "#8A9CA8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9062 60.2021C53.9062 62.2923 55.6041 63.9902 57.6943 63.9902C59.7845 63.9902 61.4824 62.2923 61.4824 60.2021C61.4824 58.1119 59.7845 56.4141 57.6943 56.4141C55.6041 56.4141 53.9062 58.1119 53.9062 60.2021Z",
    fill: "#374A57"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5513 56.9519L54.7285 44.3503C53.7777 43.7994 52.4723 43.8824 51.0234 44.7125L75.6609 58.9365C76.7852 59.5855 77.902 58.031 76.906 57.201C76.8984 57.1934 76.8909 57.1859 76.8833 57.1859C76.838 57.1481 76.7928 57.118 76.7475 57.0878L76.7173 57.118L76.5513 56.9519Z",
    fill: "#374A57"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8926 48.1161C55.8926 45.1354 53.8024 43.9281 51.2217 45.4222C48.641 46.9087 46.5508 50.5308 46.5508 53.5114C46.5508 56.4921 48.641 57.6994 51.2217 56.2053C53.8024 54.7112 55.8926 51.0892 55.8926 48.1161Z",
    fill: "#8A9CA8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5265 45.0974L47.9238 56.5332L67.404 67.7804L74.0067 56.3446L54.5265 45.0974Z",
    fill: "#8A9CA8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7061 56.665C68.1254 58.1515 66.0352 61.7736 66.0352 64.7542C66.0352 67.7348 68.1254 68.9422 70.7061 67.4481C73.2868 65.9615 75.377 62.3395 75.377 59.3589C75.377 56.3782 73.2868 55.1784 70.7061 56.665ZM73.3547 57.4648C73.8075 57.7289 74.0716 58.4156 74.0716 59.3589C74.0716 60.5587 73.6415 61.9924 72.8793 63.3054C72.1247 64.6184 71.0909 65.7125 70.0571 66.3087C69.2422 66.7765 68.5178 66.8972 68.065 66.6331C67.8613 66.5199 67.7028 66.3162 67.5821 66.0445C67.4312 65.705 67.3557 65.2673 67.3557 64.7466C67.3557 63.5544 67.7934 62.1131 68.548 60.8001C69.3025 59.4871 70.3363 58.393 71.3701 57.7893C71.8229 57.5327 72.2455 57.3743 72.6077 57.3366C72.8944 57.3139 73.151 57.3516 73.3547 57.4648Z",
    fill: "#EDEDED"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0635 59.3564C74.0635 60.5562 73.6334 61.99 72.8713 63.3029C72.1167 64.6159 71.0829 65.7101 70.0491 66.3062C69.2341 66.7741 68.5097 66.8948 68.057 66.6307C67.8532 66.5175 67.6948 66.3138 67.574 66.0421C67.4231 65.7026 67.3477 65.2649 67.3477 64.7442C67.3477 63.552 67.7853 62.1107 68.5399 60.7977C69.2945 59.4847 70.3283 58.3906 71.3621 57.7869C71.8148 57.5303 72.2374 57.3718 72.5996 57.3341C72.8939 57.3039 73.1505 57.3417 73.3542 57.4624C73.807 57.7265 74.0711 58.4207 74.0635 59.3564Z",
    fill: "#374A57"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6002 57.3438C72.238 57.3815 71.8078 57.5399 71.3626 57.7965C71.3249 57.8191 71.2947 57.8418 71.257 57.8644C71.0004 58.0229 70.7439 58.2115 70.4948 58.4228C69.7704 59.0416 69.0913 59.8641 68.548 60.8073C68.0047 61.7506 67.6274 62.7542 67.4614 63.6899C67.401 64.0143 67.3633 64.3313 67.3633 64.6331C67.3633 64.6784 67.3633 64.7161 67.3633 64.7614C67.3633 65.2821 67.4463 65.7273 67.5897 66.0593C68.0349 66.1574 68.631 66.0216 69.2724 65.6744C70.2911 65.116 71.2947 64.0747 72.0191 62.8145C72.7435 61.5544 73.151 60.1659 73.1208 59.0039C73.0906 58.2568 72.902 57.6758 72.6002 57.3438Z",
    fill: "#8A9CA8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2492 57.8574C70.9926 58.0159 70.736 58.2045 70.487 58.4158C69.7626 59.0346 69.0835 59.8571 68.5402 60.8003C67.9969 61.7436 67.6196 62.7472 67.4536 63.6829C67.3932 64.0073 67.3555 64.3243 67.3555 64.6261C67.846 64.8525 68.4949 64.7921 69.2042 64.3771C70.7285 63.4942 71.9736 61.3512 71.9736 59.5854C71.966 58.7629 71.6944 58.1668 71.2492 57.8574Z",
    fill: "#3C3C3B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4866 58.416C69.7622 59.0348 69.083 59.8573 68.5397 60.8005C67.9964 61.7438 67.6191 62.7474 67.4531 63.6831C67.8455 63.9321 68.3964 63.9094 69.0151 63.5548C70.2074 62.8681 71.1657 61.2005 71.1657 59.8271C71.1582 59.1253 70.9016 58.6348 70.4866 58.416Z",
    fill: "#1D1D1B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M68.4496 62.3092C68.8042 62.1054 69.1589 61.7281 69.4381 61.2754L70.087 61.781C69.7475 62.3167 69.3098 62.7619 68.857 63.0185C68.5099 63.2147 68.1854 63.2977 67.9062 63.2524L68.0496 62.445C68.1175 62.4526 68.2458 62.4299 68.4496 62.3092Z",
    fill: "#EDEDED"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3849 52.3616C48.1887 52.2484 48.0906 51.9541 48.1661 51.7051C48.2415 51.4561 48.4604 51.3429 48.6566 51.4561L65.3934 61.1224C65.5896 61.2356 65.6877 61.5299 65.6122 61.7789C65.5368 62.0279 65.3179 62.1411 65.1218 62.0279L48.3849 52.3616Z",
    fill: "#C6C6C6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9623 54.3783C47.7661 54.2651 47.6227 54.001 47.6378 53.7821C47.6529 53.5633 47.8265 53.4803 48.0226 53.5935L64.7595 63.2598C64.9557 63.373 65.0991 63.6371 65.084 63.856C65.0689 64.0748 64.8953 64.1578 64.6991 64.0446L47.9623 54.3783Z",
    fill: "#C6C6C6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0167 45.0958L74.2615 56.206C73.7207 56.3283 73.1605 56.5545 72.5975 56.8817C71.0569 57.7726 69.6872 59.2701 68.7108 60.9723C68.5223 61.2945 68.3501 61.6234 68.194 61.9512L68.1927 61.954C67.363 63.7245 65.1568 64.3913 63.4398 63.4008C63.4397 63.4008 63.4397 63.4008 63.4396 63.4007L47.0287 53.9239C47.0285 53.9238 47.0283 53.9237 47.0281 53.9236C46.5561 53.6489 46.3011 53.1121 46.3879 52.5804L46.3881 52.5797C46.5883 51.3423 47.0703 50.0563 47.7536 48.8713C48.6718 47.2827 49.9201 45.9295 51.2751 45.1458C52.6343 44.3674 53.7395 44.3538 54.4801 44.7829L54.4801 44.783L54.4879 44.7873C54.5326 44.8121 54.5814 44.8444 54.6269 44.8785L54.9738 45.1387L55.0167 45.0958Z",
    fill: "white",
    stroke: "#D9D9D9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7637 57.0737L76.5527 56.9531C76.6205 56.9908 76.6884 57.036 76.7562 57.0888L76.7637 57.0737Z",
    fill: "#C6C6C6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6513 62.349C63.4023 62.2056 63.1155 62.3113 63.0174 62.5905C62.9193 62.8697 63.0476 63.2168 63.2966 63.3602C63.5456 63.5035 63.8324 63.3979 63.9305 63.1187C64.0286 62.8395 63.9003 62.4999 63.6513 62.349Z",
    fill: "#374A57"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3622 59.3021C58.1132 59.1587 57.8265 59.2644 57.7284 59.5436C57.6303 59.8228 57.7585 60.1699 58.0076 60.3133C58.2566 60.4566 58.5433 60.351 58.6414 60.0718C58.7395 59.7926 58.6112 59.4455 58.3622 59.3021Z",
    fill: "#374A57"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0692 56.2435C52.8202 56.1002 52.5335 56.2058 52.4354 56.485C52.3373 56.7642 52.4656 57.1113 52.7146 57.2547C52.9636 57.3981 53.2504 57.2924 53.3484 57.0132C53.4465 56.734 53.3258 56.3944 53.0692 56.2435Z",
    fill: "#374A57"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7802 53.1927C47.5312 53.0494 47.2444 53.155 47.1463 53.4342C47.0482 53.7134 47.1765 54.0605 47.4255 54.2039C47.6745 54.3473 47.9613 54.2416 48.0594 53.9624C48.165 53.6832 48.0367 53.3361 47.7802 53.1927Z",
    fill: "#374A57"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M264.758 39.5354L267.936 38.2734V116.478L264.758 117.74V39.5354Z",
    fill: "#8C8C8C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M267.936 38.2734L271.567 41.6371V119.842L267.936 116.478V38.2734Z",
    fill: "#D9D9D9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M348.18 80.2382L343.641 77.7148V153.607L348.18 155.078V80.2382Z",
    fill: "#8C8C8C"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M344.549 82.1303L348.181 80.2383V155.079L344.549 156.551V82.1303Z",
    fill: "#D9D9D9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M268.263 95.6836L185.438 145.642L270.893 194.286L347.145 146.957L268.263 95.6836Z",
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.809 98.903L260.71 123.082L280.054 111.96V89.7148L257.809 98.903Z",
    fill: "#FB992D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.711 97.9358V123.082L241.367 111.96V89.7148L260.711 97.9358Z",
    fill: "#FFB739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.367 89.7143L248.129 93.6022L260.94 89.8381L267.472 82.4792L260.711 78.5918L241.367 89.7143Z",
    fill: "#FB992D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.949 96.9492L260.71 100.837L280.053 89.7144L273.293 85.8262L260.387 89.6447L253.949 96.9492Z",
    fill: "#F67A21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.95 106.62L248.129 103.273V93.6016L253.74 94.0398L253.95 96.9485V106.62Z",
    fill: "#FFEAC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.129 93.6016L267.472 82.4785L273.293 85.8254L253.95 96.9485L248.129 93.6016Z",
    fill: "#FFD488"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.809 76.1139L260.71 100.293L280.054 89.1708V66.9258L257.809 76.1139Z",
    fill: "#FB992D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.711 75.1468V100.293L241.367 89.1708V66.9258L260.711 75.1468Z",
    fill: "#FFB739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.367 66.9252L248.129 70.8132L260.94 67.049L267.472 59.6901L260.711 55.8027L241.367 66.9252Z",
    fill: "#FB992D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.949 74.1602L260.71 78.0478L280.053 66.9253L273.293 63.0371L260.387 66.8556L253.949 74.1602Z",
    fill: "#F67A21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.95 83.831L248.129 80.4842V70.8125L253.74 71.2507L253.95 74.1594V83.831Z",
    fill: "#FFEAC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.129 70.8125L267.472 59.6895L273.293 63.0364L253.95 74.1594L248.129 70.8125Z",
    fill: "#FFD488"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.879 44.8912V65.9831L261.535 76.5306L261.535 55.4285L279.879 44.8912Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.191 44.8906L260.535 55.366V76.5325L242.191 65.985V44.8906Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.957 48.8013L242.693 44.0296L261.034 33.4836L269.182 38.2104L250.957 48.8013Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.371 44.0296L261.033 54.5739L251.818 49.3078L269.963 38.6674L279.371 44.0296Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.967 110.298L280.868 134.477L300.212 123.354V101.109L277.967 110.298Z",
    fill: "#FB992D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.869 109.33V134.477L261.525 123.354V101.109L280.869 109.33Z",
    fill: "#FFB739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.525 101.109L268.287 104.997L281.099 101.233L287.63 93.8737L280.869 89.9863L261.525 101.109Z",
    fill: "#FB992D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.107 108.344L280.868 112.231L300.212 101.109L293.451 97.2207L280.545 101.039L274.107 108.344Z",
    fill: "#F67A21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.108 118.015L268.287 114.668V104.996L273.898 105.434L274.108 108.343V118.015Z",
    fill: "#FFEAC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.287 104.996L287.63 93.873L293.451 97.2199L274.108 108.343L268.287 104.996Z",
    fill: "#FFD488"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.967 87.5085L280.868 111.688L300.212 100.565V78.3203L277.967 87.5085Z",
    fill: "#FB992D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.869 86.5413V111.688L261.525 100.565V78.3203L280.869 86.5413Z",
    fill: "#FFB739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.525 78.3198L268.287 82.2077L281.099 78.4436L287.63 71.0846L280.869 67.1973L261.525 78.3198Z",
    fill: "#FB992D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.107 85.5547L280.868 89.4424L300.212 78.3199L293.451 74.4316L280.545 78.2501L274.107 85.5547Z",
    fill: "#F67A21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.108 95.2256L268.287 91.8788V82.207L273.898 82.6453L274.108 85.5539V95.2256Z",
    fill: "#FFEAC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.287 82.2071L287.63 71.084L293.451 74.4309L274.108 85.554L268.287 82.2071Z",
    fill: "#FFD488"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.879 56.8912V77.9831L281.535 88.5306L281.535 67.4285L299.879 56.8912Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.191 56.8906L280.535 67.366V88.5325L262.191 77.985V56.8906Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.957 60.8013L262.693 56.0296L281.034 45.4836L289.182 50.2104L270.957 60.8013Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.371 56.0296L281.033 66.5739L271.818 61.3078L289.963 50.6674L299.371 56.0296Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.002 121.688L301.903 145.867L321.247 134.745V112.5L299.002 121.688Z",
    fill: "#FB992D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.904 120.723V145.869L282.561 134.747V112.502L301.904 120.723Z",
    fill: "#FFB739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.561 112.501L289.323 116.389L302.134 112.625L308.665 105.266L301.904 101.379L282.561 112.501Z",
    fill: "#FB992D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.143 119.736L301.903 123.624L321.247 112.502L314.486 108.613L301.58 112.432L295.143 119.736Z",
    fill: "#F67A21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.143 129.409L289.322 126.062V116.391L294.933 116.829L295.143 119.738V129.409Z",
    fill: "#FFEAC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.322 116.389L308.665 105.266L314.487 108.613L295.143 119.736L289.322 116.389Z",
    fill: "#FFD488"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.002 98.8991L301.903 123.078L321.247 111.956V89.7109L299.002 98.8991Z",
    fill: "#FB992D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.904 97.9339V123.08L282.561 111.958V89.7129L301.904 97.9339Z",
    fill: "#FFB739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.561 89.7123L289.323 93.6003L302.134 89.8361L308.665 82.4772L301.904 78.5898L282.561 89.7123Z",
    fill: "#FB992D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.143 96.9473L301.903 100.835L321.247 89.7124L314.486 85.8242L301.58 89.6427L295.143 96.9473Z",
    fill: "#F67A21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.143 106.62L289.322 103.273V93.6016L294.933 94.0398L295.143 96.9485V106.62Z",
    fill: "#FFEAC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.322 93.5996L308.665 82.4766L314.487 85.8235L295.143 96.9465L289.322 93.5996Z",
    fill: "#FFD488"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.879 67.8912V88.9831L302.535 99.5306L302.535 78.4285L320.879 67.8912Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.191 67.8906L301.535 78.366V99.5325L283.191 88.985V67.8906Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.957 71.8013L283.693 67.0296L302.034 56.4836L310.182 61.2104L291.957 71.8013Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.371 67.0296L302.033 77.5739L292.818 72.3078L310.963 61.6674L320.371 67.0296Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_9008_208313)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.879 124.891V145.983L322.535 156.531L322.535 135.428L340.879 124.891Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.191 124.891L321.535 135.366V156.533L303.191 145.985V124.891Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.957 128.801L303.693 124.03L322.034 113.484L330.182 118.21L311.957 128.801Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.371 124.03L322.033 134.574L312.818 129.308L330.963 118.667L340.371 124.03Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_9008_208313)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.879 101.891V122.983L322.535 133.531L322.535 112.428L340.879 101.891Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.191 101.891L321.535 112.366V133.533L303.191 122.985V101.891Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.957 105.801L303.693 101.03L322.034 90.4836L330.182 95.2104L311.957 105.801Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.371 101.03L322.033 111.574L312.818 106.308L330.963 95.6674L340.371 101.03Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.879 78.8912V99.9831L322.535 110.531L322.535 89.4285L340.879 78.8912Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.191 78.8906L321.535 89.366V110.533L303.191 99.985V78.8906Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.957 82.8013L303.693 78.0296L322.034 67.4836L330.182 72.2104L311.957 82.8013Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.371 78.0296L322.033 88.5739L312.818 83.3078L330.963 72.6674L340.371 78.0296Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M317.785 162.294L309.897 157.911L308.582 151.338L323.482 158.788V161.643L317.876 165.124L317.785 162.294Z",
    fill: "#E00606"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M230.18 105.598L320.557 160.575V90.9998L230.18 40.7344V105.598Z",
    fill: "url(#paint0_linear_9008_208313)"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.516 115.555L234.417 139.735L253.761 128.612V106.367L231.516 115.555Z",
    fill: "#FB992D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.418 114.588V139.735L215.074 128.612V106.367L234.418 114.588Z",
    fill: "#FFB739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.074 106.367L221.836 110.255L234.647 106.49L241.179 99.1315L234.418 95.2441L215.074 106.367Z",
    fill: "#FB992D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.656 113.602L234.417 117.489L253.76 106.367L247 102.479L234.094 106.297L227.656 113.602Z",
    fill: "#F67A21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.657 123.272L221.836 119.926V110.254L227.447 110.692L227.657 113.601V123.272Z",
    fill: "#FFEAC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.836 110.254L241.179 99.1309L247 102.478L227.657 113.601L221.836 110.254Z",
    fill: "#FFD488"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.879 84.8912V105.983L234.535 116.531L234.535 95.4285L252.879 84.8912Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.191 84.8906L233.535 95.366V116.533L215.191 105.985V84.8906Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.957 88.8013L215.693 84.0296L234.034 73.4836L242.182 78.2104L223.957 88.8013Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.371 84.0296L234.033 94.5739L224.818 89.3078L242.963 78.6674L252.371 84.0296Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.879 61.8912V82.9831L234.535 93.5306L234.535 72.4285L252.879 61.8912Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.191 61.8906L233.535 72.366V93.5325L215.191 82.985V61.8906Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.957 65.8013L215.693 61.0296L234.034 50.4836L242.182 55.2104L223.957 65.8013Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.371 61.0296L234.033 71.5739L224.818 66.3078L242.963 55.6674L252.371 61.0296Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.877 119.891V140.983L255.533 151.531L255.533 130.428L273.877 119.891Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.189 119.891L254.533 130.366V151.533L236.189 140.985V119.891Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.955 123.801L236.691 119.03L255.032 108.484L263.18 113.21L244.955 123.801Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.369 119.03L255.031 129.574L245.816 124.308L263.961 113.667L273.369 119.03Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.877 96.8912V117.983L255.533 128.531L255.533 107.428L273.877 96.8912Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.189 96.8906L254.533 107.366V128.533L236.189 117.985V96.8906Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.955 100.801L236.691 96.0296L255.032 85.4836L263.18 90.2104L244.955 100.801Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.369 96.0296L255.031 106.574L245.816 101.308L263.961 90.6674L273.369 96.0296Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.877 73.8912V94.9831L255.533 105.531L255.533 84.4285L273.877 73.8912Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.189 73.8906L254.533 84.366V105.533L236.189 94.985V73.8906Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.955 77.8013L236.691 73.0296L255.032 62.4836L263.18 67.2104L244.955 77.8013Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.369 73.0296L255.031 83.5739L245.816 78.3078L263.961 67.6674L273.369 73.0296Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.877 131.891V152.983L275.533 163.531L275.533 142.428L293.877 131.891Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.189 131.891L274.533 142.366V163.533L256.189 152.985V131.891Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.955 135.801L256.691 131.03L275.032 120.484L283.18 125.21L264.955 135.801Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.369 131.03L275.031 141.574L265.816 136.308L283.961 125.667L293.369 131.03Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.877 108.891V129.983L275.533 140.531L275.533 119.428L293.877 108.891Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.189 108.891L274.533 119.366V140.533L256.189 129.985V108.891Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.955 112.801L256.691 108.03L275.032 97.4836L283.18 102.21L264.955 112.801Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.369 108.03L275.031 118.574L265.816 113.308L283.961 102.667L293.369 108.03Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip22_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.877 85.8912V106.983L275.533 117.531L275.533 96.4285L293.877 85.8912Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.189 85.8906L274.533 96.366V117.533L256.189 106.985V85.8906Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.955 89.8013L256.691 85.0296L275.032 74.4836L283.18 79.2104L264.955 89.8013Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.369 85.0296L275.031 95.5739L265.816 90.3078L283.961 79.6674L293.369 85.0296Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip23_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.877 125.891V146.983L211.533 157.531L211.533 136.428L229.877 125.891Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.189 125.891L210.533 136.366V157.533L192.189 146.985V125.891Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.955 129.801L192.691 125.03L211.032 114.484L219.18 119.21L200.955 129.801Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.369 125.03L211.031 135.574L201.816 130.308L219.961 119.667L229.369 125.03Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip24_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.877 102.891V123.983L211.533 134.531L211.533 113.428L229.877 102.891Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.189 102.891L210.533 113.366V134.533L192.189 123.985V102.891Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.955 106.801L192.691 102.03L211.032 91.4836L219.18 96.2104L200.955 106.801Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.369 102.03L211.031 112.574L201.816 107.308L219.961 96.6674L229.369 102.03Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip25_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.877 79.8912V100.983L211.533 111.531L211.533 90.4285L229.877 79.8912Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.189 79.8906L210.533 90.366V111.533L192.189 100.985V79.8906Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.955 83.8013L192.691 79.0296L211.032 68.4836L219.18 73.2104L200.955 83.8013Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.369 79.0296L211.031 89.5739L201.816 84.3078L219.961 73.6674L229.369 79.0296Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip26_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.877 142.891V163.983L295.533 174.531L295.533 153.428L313.877 142.891Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.189 142.891L294.533 153.366V174.533L276.189 163.985V142.891Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.955 146.801L276.691 142.03L295.032 131.484L303.18 136.21L284.955 146.801Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.369 142.03L295.031 152.574L285.816 147.308L303.961 136.667L313.369 142.03Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip27_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.877 119.891V140.983L295.533 151.531L295.533 130.428L313.877 119.891Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.189 119.891L294.533 130.366V151.533L276.189 140.985V119.891Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.955 123.801L276.691 119.03L295.032 108.484L303.18 113.21L284.955 123.801Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.369 119.03L295.031 129.574L285.816 124.308L303.961 113.667L313.369 119.03Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip28_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.877 97.8912V118.983L295.533 129.531L295.533 108.428L313.877 97.8912Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.189 97.8906L294.533 108.366V129.533L276.189 118.985V97.8906Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.955 101.801L276.691 97.0296L295.032 86.4836L303.18 91.2104L284.955 101.801Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.369 97.0296L295.031 107.574L285.816 102.308L303.961 91.6674L313.369 97.0296Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip29_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.877 136.891V157.983L231.533 168.531L231.533 147.428L249.877 136.891Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.189 136.891L230.533 147.366V168.533L212.189 157.985V136.891Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.955 140.801L212.691 136.03L231.032 125.484L239.18 130.21L220.955 140.801Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.369 136.03L231.031 146.574L221.816 141.308L239.961 130.667L249.369 136.03Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip30_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.877 113.891V134.983L231.533 145.531L231.533 124.428L249.877 113.891Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.189 113.891L230.533 124.366V145.533L212.189 134.985V113.891Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.955 117.801L212.691 113.03L231.032 102.484L239.18 107.21L220.955 117.801Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.369 113.03L231.031 123.574L221.816 118.308L239.961 107.667L249.369 113.03Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip31_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.877 148.891V169.983L251.533 180.531L251.533 159.428L269.877 148.891Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.189 148.891L250.533 159.366V180.533L232.189 169.985V148.891Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.955 152.801L232.691 148.03L251.032 137.484L259.18 142.21L240.955 152.801Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.369 148.03L251.031 158.574L241.816 153.308L259.961 142.667L269.369 148.03Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip32_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.877 159.891V180.983L271.533 191.531L271.533 170.428L289.877 159.891Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.189 159.891L270.533 170.366V191.533L252.189 180.985V159.891Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.955 163.801L252.691 159.03L271.032 148.484L279.18 153.21L260.955 163.801Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.369 159.03L271.031 169.574L261.816 164.308L279.961 153.667L289.369 159.03Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip33_9008_208313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.877 136.891V157.983L271.533 168.531L271.533 147.428L289.877 136.891Z",
    fill: "#FAFAFA",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.189 136.891L270.533 147.366V168.533L252.189 157.985V136.891Z",
    fill: "#FAFAFA",
    stroke: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.955 140.801L252.691 136.03L271.032 125.484L279.18 130.21L260.955 140.801Z",
    fill: "#FAFAFA",
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.369 136.03L271.031 146.574L261.816 141.308L279.961 130.667L289.369 136.03Z",
    fill: "#FAFAFA",
    stroke: "#606060"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M185 76.3479L188.178 75.0859V157.496L185 154.552V76.3479Z",
    fill: "#8C8C8C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M185 76.3477L188.632 79.7113V157.916L185 154.552V76.3477Z",
    fill: "#D9D9D9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M271.018 125.188L274.195 123.926V200.869L271.018 203.392V125.188Z",
    fill: "#8C8C8C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M267.387 123.293L271.019 125.185V203.39L267.387 201.498V123.293Z",
    fill: "#D9D9D9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9553 62.6854L185.034 76.3279",
    stroke: "#69D2FF",
    strokeWidth: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8652 62.6406L270.99 125.146",
    stroke: "#69D2FF",
    strokeWidth: 0.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8652 62.6836L185.119 145.872",
    stroke: "#69D2FF",
    strokeWidth: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7695 62.5684L270.896 192.803",
    stroke: "#69D2FF",
    strokeWidth: 0.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M184.871 145.717L70.1758 62.7734L184.871 76.4579L270.762 125.166L270.099 192.454L184.871 145.717Z",
    fill: "url(#paint1_linear_9008_208313)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9008_208313",
    x1: 275.368,
    y1: 44.9277,
    x2: 275.368,
    y2: 160.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5545",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA5545",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9008_208313",
    x1: 16.884,
    y1: -33.9326,
    x2: 158.771,
    y2: 161.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96C6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96C6F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(238.465 78.5918)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(238.465 55.8027)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(238.789 32.9062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(258.623 89.9863)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(258.623 67.1973)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(258.789 44.9062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(279.658 101.379)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(279.658 78.5898)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(279.789 55.9062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(299.816 112.773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(299.789 112.906)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(299.816 89.9844)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(299.789 89.9062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(299.789 66.9062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(212.172 95.2441)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(211.789 72.9062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(211.789 49.9062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(232.787 107.906)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(232.787 84.9062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(232.787 61.9062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(252.787 119.906)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(252.787 96.9062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(252.787 73.9062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(188.787 113.906)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(188.787 90.9062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(188.787 67.9062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(272.787 130.906)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(272.787 107.906)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip28_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(272.787 85.9062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip29_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(208.787 124.906)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip30_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(208.787 101.906)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip31_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(228.787 136.906)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip32_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(248.787 147.906)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip33_9008_208313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.49,
    height: 44.49,
    fill: "white",
    transform: "translate(248.787 124.906)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvBox);
export default __webpack_public_path__ + "static/media/invBox.0d26bc144c806231ae2b161dc8acb8ea.svg";
export { ForwardRef as ReactComponent };